// AI chat (sidebar entry, dashboard tile, messaging assistant) is being rolled out to a
// limited set of production accounts while it's still being validated. Non-production hosts
// (dev/staging/local) show it to everyone — same hostname rule as Setting.js's api_base_url
// switch and aiConsent.js's isProductionHost.
const PRODUCTION_ALLOWED_ACCOUNT_IDS = [
  '6df0655b-9470-4864-066a-08d9f54856f9',
  'c3463201-cac1-47c3-986c-08da0b53cbf8',
  '07bf885e-4865-4b96-04b7-08db6b1dff16',
];

const isProductionHost = () => window.location.hostname.includes('app');

export const isAiFeatureVisible = (accountId) => {
  if (!isProductionHost()) {
    return true;
  }
  return PRODUCTION_ALLOWED_ACCOUNT_IDS.includes(accountId);
};
